import React from "react";

import initialState from "./initial-state";

import IAction from "./action";
import IMenu from "../../presentation/interfaces/menu";

export interface IContext {
  menu: IMenu;
  dispatch: React.Dispatch<IAction>;
}

const MenuContext = React.createContext<IContext>({
  menu: initialState,
  dispatch: () => null,
});

export default MenuContext;
